import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { PiListChecksDuotone, PiPlus } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

export const SubmenuGradesPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Sekolah",
    });
  }, [setHeader]);
  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.HEALTH_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
            <PiPlus
              className="card-icon tw-text-[#00b894] tw-relative tw-z-10"
              // style={{ background: "#c4e9c4" }}
            />
            <div className="card-name">Kesehatan</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.ABSENCE_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
            <PiListChecksDuotone
              className="card-icon"
              // style={{ background: "#eee" }}
            />
            <div className="card-name">Absensi</div>
          </div>
        </div>
      </div>
    </div>
  );
};
